import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Store, Mail, Lock, User, Building2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const inputCls = 'w-full pl-12 pr-4 py-3 rounded-2xl border border-stone-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none transition-all font-body text-sm';

const MerchantRegisterPage = () => {
  const navigate = useNavigate();
  const { registerMerchant } = useAuth();
  const [mosques, setMosques] = useState([]);
  const [form, setForm] = useState({ name: '', email: '', password: '', mosque_id: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/mosques`, { params: { limit: 200 } }).then((r) => setMosques(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.mosque_id) return setError('Pilih masjid tempat Anda berjualan');
    setLoading(true);
    const res = await registerMerchant(form);
    setLoading(false);
    if (res.success) navigate('/merchant');
    else setError(res.error);
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="min-h-screen bg-gradient-to-b from-amber-50 to-emerald-50 flex items-center justify-center px-6 py-8">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-xl border border-stone-100 p-8">
          <div className="text-center mb-6">
            <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto mb-3"><Store className="w-8 h-8 text-amber-600" /></div>
            <h1 className="text-2xl font-heading font-bold text-primary-dark">Daftar Merchant UMKM</h1>
            <p className="text-sm font-body text-text-secondary mt-1">Pasang iklan usaha Anda di masjid</p>
          </div>
          {error && <div data-testid="merchant-register-error" className="bg-red-50 border border-red-200 rounded-2xl p-4 mb-4"><p className="text-sm font-body text-red-800">{error}</p></div>}
          <form onSubmit={submit} className="space-y-4">
            <div className="relative"><User className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-stone-400" /><input data-testid="merchant-name-input" className={inputCls} placeholder="Nama Anda" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required /></div>
            <div className="relative"><Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-stone-400" /><input data-testid="merchant-email-input" type="email" className={inputCls} placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /></div>
            <div className="relative"><Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-stone-400" /><input data-testid="merchant-password-input" type="password" className={inputCls} placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required /></div>
            <div className="relative"><Building2 className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-stone-400 z-10" />
              <select data-testid="merchant-mosque-select" className={`${inputCls} appearance-none`} value={form.mosque_id} onChange={(e) => setForm({ ...form, mosque_id: e.target.value })} required>
                <option value="">Pilih Masjid</option>
                {mosques.map((m) => <option key={m.id} value={m.id}>{m.name} — {m.regency_name}</option>)}
              </select>
            </div>
            <button type="submit" data-testid="merchant-register-submit" disabled={loading} className="w-full bg-emerald-700 hover:bg-emerald-800 disabled:bg-emerald-400 text-white font-body font-semibold py-3 rounded-full transition-colors">
              {loading ? 'Memproses...' : 'Daftar & Mulai Berjualan'}
            </button>
          </form>
          <div className="mt-5 text-center space-y-2">
            <button onClick={() => navigate('/login')} className="block w-full text-sm font-body text-emerald-700 hover:text-emerald-800 font-medium">Sudah punya akun? Masuk</button>
            <button onClick={() => navigate('/')} className="text-sm font-body text-stone-500 hover:text-stone-700 font-medium">← Kembali ke Beranda</button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default MerchantRegisterPage;
